import Phaser from 'phaser'
import LevelDefs from './levelDefs'
import Platform from '/actors/platform'

export const MAX_HOPSIZE = 1200 // so, normally, the max hopSize is 1100
export const MIN_HOPSIZE = 300
export const AVG_HOPSIZE = MIN_HOPSIZE + (MAX_HOPSIZE - MIN_HOPSIZE) / 2 // 750
const EASY_HOPSIZE = 850
const MIN_RATING = 50
const MAX_RATING = 2500
const MIN_GAPSIZE = 200
const MIN_GAP_EDGE = 25
const GUIDE_WIDTH = 175

const SHAPE_LINE = 0
const SHAPE_TRIANGLE = 1
const SHAPE_SLOPEDOWN = 2
const SHAPE_SLOPEUP = 3
// const SHAPE_TOP = 4

const PLATFORM_PADDING = 110
const MIN_OBSTACLE_DIST = 110
const MIN_MOVER_DIST = 130 // TODO Do something with this..
const EST_HOP_DURATION = 1363
const EST_FALL_DURATION = 660

const MIN_PLATFORM_HEIGHT = 500

const HEIGHT_DIFFS = [350, 275, 200, 0, 0, 0, 0, 0, 0, 0, 0, 0, -150, -200, -250, -300, -350, -400, -425]
const POS_HEIGHT_DIFFS = [350, 275, 200]
const NEG_HEIGHT_DIFFS = [-200, -250, -300, -350, -400, -425]
const GAPS = [-10, -10, -10, 300, 400, 500, 600]
const WIDTHS = [400, 400, 400, 400, 400, 500, 500, 500, 500, 600, 600, 600, 700, 700, 800, 800, 900, 900, 1000, 1000, 1200, 1600, 2200, 3000, 4000]

export default class LevelGenerator {
  constructor (scene) {
    this.scene = scene
    this.spawner = scene.spawner
    this.guide = scene.spawner.guide

    this.relativeRating = 1
    this.platforms = []
    this.topPlatformX = -1
    this.lastMovingObstacleX = -1
  }

  log (text) {
    // console.log(text)
  }

  getPlatformAt (x) {
    for (var i = 0; i < this.platforms.length; i++) {
      var platform = this.platforms[i]
      if (x > platform.image.x - (platform.width / 2) && x < platform.image.x + (platform.width / 2)) {
        return platform
      }
    }
    return null
  }

  startPlatform (x, y) {
    this.platformX = x
    this.platformY = y
    this.couldBeMovingPlatform = x > 100 && this.rnd.frac() < this.relativeRating
  }

  endPlatform (x, isBreakable = false, isMoving = false, isFirstOrLast = false, nPoints, hopIndex) {
    const w = x - this.platformX
    const cX = x - (w / 2)
    const h = 2000 - this.platformY
    const cY = 2000 - (h / 2)

    if (isMoving) {
      this.addMovingPlatform(cX, this.platformY, w, nPoints, hopIndex)
    } else {
      this.addPlatform(cX, cY, w, h, isBreakable)
    }

    this.couldBeMovingPlatform = false
  }

  generateHops (seed, rating) {
    this.relativeRating = (rating - MIN_RATING) / (MAX_RATING - MIN_RATING)
    this.log('>>>>>>>>>>> Generating level with relativeRating: ' + this.relativeRating + ' and seed: ' + seed)

    // Use provided seed for RNG:
    this.rnd = Phaser.Math.RND
    this.rnd.sow('' + seed + rating)

    // 1. generate the guide.
    // 1a. determine number of Hops:
    this.nHops = 1
    var rStep = 0.04
    for (var rR = 0.04; rR < 1; rR += rStep) {
      if (this.relativeRating > rR) {
        if (this.rnd.frac() < 0.75) {
          this.nHops++
        }
      }
      rStep += 0.01
    }

    this.guideData = [this.nHops + 1]

    // 1b. determine hopSizes:
    var hopSizeLimitMin = AVG_HOPSIZE - (this.relativeRating * (AVG_HOPSIZE - MIN_HOPSIZE))
    var hopSizeLimitMax = 0 // This is set later

    var lastX = 500
    var lastHopSize = lastX

    var maxHopSizeVarianceUp = 0 // This is set later
    var maxHopSizeVarianceDown = this.relativeRating * AVG_HOPSIZE * 1.5 // allow abrupt stops
    this.guideData[0] = lastX
    for (var i = 1; i < this.nHops + 1; i++) {
      hopSizeLimitMax = AVG_HOPSIZE + (this.relativeRating * (AVG_HOPSIZE - MIN_HOPSIZE))
      maxHopSizeVarianceUp = this.relativeRating * AVG_HOPSIZE * (1 - (lastHopSize / MAX_HOPSIZE)) // Give some space to accelerate

      var maxHopSize = Math.min(lastHopSize + maxHopSizeVarianceUp, hopSizeLimitMax)
      var minHopSize = Math.max(lastHopSize - maxHopSizeVarianceDown, hopSizeLimitMin)
      if (i === 1) {
        maxHopSize = Math.min(maxHopSize, 900)
      }

      lastHopSize = this.rnd.between(minHopSize, maxHopSize)

      // Early levels should have easy hopSizes (which is different than the average hopSize)
      if (this.relativeRating <= 0.30) {
        lastHopSize = Phaser.Math.Linear(EASY_HOPSIZE, lastHopSize, this.relativeRating / 0.30)
      }
      lastX = lastX + lastHopSize
      this.guideData[i] = lastX
    }

    // 2. Determine hop types and difficulty:
    // this.hopTypes = this.generateHopTypes(this.relativeRating, this.nHops)
    // this.log('and hopTypes:')
    // this.log(this.hopTypes)
  }

  generateGuide (seed, rating) {
    // seed = Phaser.Math.Between(100, 202000)
    // rating = 2500//Phaser.Math.Linear(MIN_RATING, MAX_RATING, 0.9959183673469387)
    this.generateHops(seed, rating)

    // The first hop is more hard-coded:
    const firstHopSize = this.guideData[1] - this.guideData[0]
    const firstHopX = this.guideData[0]
    const firstHopY = 410
    this.startPlatform(-1100, firstHopY - 10, false)
    this.scene.spawner.addGuideStart(firstHopX, firstHopY, firstHopSize, false)
    this.guide = this.scene.spawner.guide
    let prevX = firstHopX + firstHopSize
    let prevY = firstHopY
    this.isFirstPlatform = true

    let needsToStartLastPlatform = false

    // And now the rest:
    let nPointsThisPlatform = 2
    for (var i = 0; i < this.nHops - 1; i++) {
      const hopSize = this.guideData[i + 2] - this.guideData[i + 1]
      let yDiff = 0
      if (this.rnd.frac() < 0.75) { // } || nPointsThisPlatform > 4) {
        if (this.rnd.frac() < 0.3) {
          yDiff = this.rnd.between(200, 350)
        } else {
          yDiff = this.rnd.between(-125, -425 + Math.max(0, hopSize - AVG_HOPSIZE))
        }
      }
      const y = prevY + yDiff
      const x = this.guideData[i + 2]

      if (y === prevY) {
        // this.log('adding point (y=y) . ', this.couldBeMovingPlatform)
        this.guide.editor.addPoint(x, y, false, this.couldBeMovingPlatform, this.couldBeMovingPlatform)

        // if the last platforms is going to be a moving platform, end it and start a new platform
        if (this.couldBeMovingPlatform && i >= this.nHops - 2) {
          this.guide.editor.points[this.guide.editor.points.length - (nPointsThisPlatform + 1)].noHeightBehind = true
          if (this.platforms[this.platforms.length - 1].typeName === 'sPl' && !this.platforms[this.platforms.length - 1].isMoving) {
            this.platforms[this.platforms.length - 1].handles[0].setRight(this.guide.editor.points[this.guide.editor.points.length - (nPointsThisPlatform + 2)].x + PLATFORM_PADDING)
          }
          this.platformX = this.guide.editor.points[this.guide.editor.points.length - (nPointsThisPlatform + 1)].x
          this.endPlatform(x, false, true, false, nPointsThisPlatform + 1, i + 1)
          needsToStartLastPlatform = true
          nPointsThisPlatform = 1
        } else {
          nPointsThisPlatform++
        }
      } else {
        let endX = prevX + PLATFORM_PADDING
        let startX = x - PLATFORM_PADDING
        const gapSize = startX - endX
        const isBreakable = nPointsThisPlatform <= 1 && this.rnd.frac() < 0.2 * this.relativeRating// (this.relativeRating * this.relativeRating)
        let isGap = true

        const isMoving = this.couldBeMovingPlatform && nPointsThisPlatform > 1
        // Close small gaps and close a couple of random large gaps as well
        if (!isMoving && !isBreakable && (gapSize < 400 || this.rnd.frac() < (1 - this.relativeRating))) {
          this.log('closing gap between ' + this.guideData[i + 1] + ' and ' + this.guideData[i + 2])
          let t = 0.5
          if (y < prevY) {
            t = 0.75
          } else {
            t = 0.25
          }
          endX = Phaser.Math.Linear(endX, startX, t)
          startX = endX - 20
          isGap = false
          // this.log('setting endX to', endX)
          // this.log('setting startX to', startX)
        }

        this.guide.editor.addPoint(x, y, false, isBreakable || isMoving || isGap)

        if (isMoving) {
          // this.log('re-opening a closed gap before a moving platform')
          this.guide.editor.points[this.guide.editor.points.length - (nPointsThisPlatform + 1)].noHeightBehind = true
          if (this.platforms[this.platforms.length - 1].typeName === 'sPl' && !this.platforms[this.platforms.length - 1].isMoving) {
            this.platforms[this.platforms.length - 1].handles[0].setRight(this.guide.editor.points[this.guide.editor.points.length - (nPointsThisPlatform + 2)].x + PLATFORM_PADDING)
          }
          this.platformX = this.guide.editor.points[this.guide.editor.points.length - (nPointsThisPlatform + 1)].x// - 200
        }

        if (isBreakable) {
          // this.log('re-opening a closed gap before a breakable platform')
          this.guide.editor.points[this.guide.editor.points.length - 2].noHeightBehind = true
          this.guide.editor.points[this.guide.editor.points.length - 2].noHeightInFront = true

          // re-open the gap to the previous platform:
          if (this.platforms[this.platforms.length - 1].typeName === 'sPl' && !this.platforms[this.platforms.length - 1].isMoving) {
            this.platforms[this.platforms.length - 1].handles[0].setRight(this.guide.editor.points[this.guide.editor.points.length - 3].x + PLATFORM_PADDING)
          }

          this.platformX = prevX - PLATFORM_PADDING
          endX = prevX + PLATFORM_PADDING
          startX = x - PLATFORM_PADDING
        }

        this.endPlatform(isMoving ? prevX : endX, isBreakable, isMoving, this.isFirstPlatform, nPointsThisPlatform, i)
        this.isFirstPlatform = false
        this.startPlatform(startX, y - 10)

        nPointsThisPlatform = 1
      }

      prevX = x
      prevY = y
    }

    // make sure we always have some kind of yDiff
    if (this.nHops < 2) {
      prevY += this.rnd.between(-125, -225)
      this.endPlatform(prevX + 3000, false, false, true, nPointsThisPlatform, i)
      needsToStartLastPlatform = true
    }

    if (needsToStartLastPlatform) {
      this.startPlatform(prevX + EASY_HOPSIZE - PLATFORM_PADDING, prevY - 10)
    }
    this.guide.editor.addPoint(prevX + EASY_HOPSIZE, prevY)
    this.endPlatform(prevX + 3000, false, false, true, nPointsThisPlatform, i)

    this.guide.refresh()
    this.addCake(prevX + 1800, prevY - 170)
  }

  addCake (x, y) {
    var def = { type: 'cake', data: { x, y } }
    this.scene.spawner.spawnFromDef(def, false)
  }

  addPlatform (x, y, w, h, isBreakable) {
    if (isBreakable) {
      let width = w
      if (this.relativeRating < 0.25) {
        width = this.rnd.between(400, 500)
      } else if (this.relativeRating < 0.5) {
        width = this.rnd.between(300, 400)
      } else if (this.relativeRating < 0.75) {
        width = this.rnd.between(200, 300)
      }
      var def = { type: 'bPl', data: { x: x, y: y /* - (h / 2) + 50 */, width: width, height: h } }// 100 } }
    } else {
      var def = { type: 'sPl', data: { x: x, y: y, width: w, height: h } }
    }
    this.platforms.push(this.scene.spawner.spawnFromDef(def, false))
  }

  addMovingPlatform (x, y, w, nPoints, hopIndex) {
    const p0 = { x: x - (w / 2), y: y + 50 }
    const p1 = { x: x + (w / 2), y: y + 50 }
    const dist = (p1.x - p0.x)
    let slowStart = true
    let speed = 1000 * (dist / (EST_HOP_DURATION * (nPoints - 1)))
    this.log('adding a moving platform for ', nPoints)
    this.log('calculated speed:' + speed)
    if (speed > 450) {
      this.log('Too fast. Inserting an additional hop.')
      this.guide.editor.insertPoint(p0.x + (dist / nPoints), p0.y - 40, false, true, true)
      this.log('spacing out hops evenly, but less near the end')
      const p0Index = this.guide.editor.getPointIndexAt(p0.x)
      for (var i = 0; i <= nPoints; i++) {
        const size = Phaser.Math.Linear(0, dist, Math.pow(i / nPoints, 1.25))
        this.guide.editor.points[p0Index + i].x = p0.x + size
      }
      speed = 1000 * (dist / (EST_HOP_DURATION * nPoints))
    } else {
      this.log('spacing out hops evenly.')
      slowStart = false
      const p0Index = this.guide.editor.getPointIndexAt(p0.x)
      for (var i = 0; i <= nPoints - 1; i++) {
        const size = Phaser.Math.Linear(0, dist, i / (nPoints - 1))// Math.pow(i / (nPoints - 1), 1.25))
        this.guide.editor.points[p0Index + i].x = p0.x + size
      }
    }

    var def = {
      type: 'sPl',
      data: {
        x: p0.x,
        y: p0.y,
        width: 400,
        height: 100,
        isMoving: true,
        speed: speed,
        slowStart: slowStart,
        p0: p0,
        p1: p1
      }
    }
    this.platforms.push(this.scene.spawner.spawnFromDef(def, false))
  }

  spawnMovingObstacle (p0, p1, delay = 0) {
    var def = {
      type: 'obs',
      data: {
        isMoving: true,
        delay: delay,
        x: p0.x,
        y: p0.y,
        p0: { x: p0.x, y: p0.y },
        p1: { x: p1.x, y: p1.y }
      }
    }
    return this.scene.spawner.spawnFromDef(def, false)
  }

  startTopPlatform (x, y) {
    this.topPlatformX = x
    this.topPlatformY = y
  }

  continueTopPlatform (x, y) {
    if (y < this.topPlatformY - 50) {
      this.endTopPlatform(this.lastTopObstacleX + 100)
      this.startTopPlatform(this.lastTopObstacleX, y)
    } else if (y > this.topPlatformY + 50) {
      this.endTopPlatform(x)
      this.startTopPlatform(x - 100, y)
    } else {
      this.topPlatformY = Math.min(this.topPlatformY, y)
    }
  }

  endTopPlatform (x) {
    const w = x - this.topPlatformX
    const cX = x - (w / 2)
    const h = 600
    const cY = this.topPlatformY - (h / 2) + 50

    if (w > 0) {
      var def = { type: 'sPl', data: { x: cX, y: cY, width: w, height: h } }
      this.scene.spawner.spawnFromDef(def, false)
    }
  }

  spawnTopObstacle (x, y, height) {
    // make sure all obstacles are at least 150px long
    height = Math.min(-150, height)

    // start the very first platform
    if (this.topPlatformX < 0) {
      this.startTopPlatform(x - 100, y + height - 100)
    }

    // finish up a platform?
    if (x < this.lastTopObstacleX + 700) {
      this.continueTopPlatform(x, y + height - 100)
    } else { // if (x > this.lastTopObstacleX + 600) {
      this.endTopPlatform(this.lastTopObstacleX + 100)
      this.startTopPlatform(x - 100, y + height - 100)
    }

    // simply to make sure the obstacle fully extends into its platform:
    height -= 300

    // and spawn:
    y -= this.makeTopObstacleEasier(this.relativeRating)
    var def = { type: 'obs', data: { x: x, y: y, height: height } }
    this.scene.spawner.spawnFromDef(def, false)

    // state:
    this.lastTopObstacleX = x
  }

  newGenerateLevel (seed, rating) {
    this.scene.spawner.clearLevel()
    this.generateGuide(seed, rating)
    this.generateAllObstacles()
    this.raisePlatforms()
    // this.scene.spawner.convertGuideToTexture()
  }

  raisePlatforms () {
    const y = this.scene.player.gameoverThreshold// this.lowestPlatformY + MIN_PLATFORM_HEIGHT
    for (var i = 0; i < this.platforms.length; i++) {
      // var platform = this.platforms[i]

      if (this.platforms[i].typeName === 'sPl' && !this.platforms[i].isMoving) {
        this.platforms[i].handles[0].setBottom(y)// Right(this.guide.editor.points[this.guide.editor.points.length - 3].x + 100)
      }

      // if (x > platform.image.x - (platform.width / 2) && x < platform.image.x + (platform.width / 2)) {
      // return platform
      // }
    }
  }

  generateAllObstacles () {
    var p0
    var p1
    var p2
    var pMin1
    let lastX = 0
    let lastMovingPlatformY = -10000

    for (var i = 0; i < this.guide.editor.points.length - 1; i++) {
      p0 = this.guide.editor.points[i]
      p1 = this.guide.editor.points[i + 1]
      if (i + 2 < this.guide.editor.points.length) {
        p2 = this.guide.editor.points[i + 2]
      } else {
        p2 = this.guide.editor.points[i + 1]
      }
      if (i - 1 >= 0) {
        pMin1 = this.guide.editor.points[i - 1]
      }

      if (p1.start) {
        continue
      }

      const pl0 = this.getPlatformAt(p0.x)
      const pl1 = this.getPlatformAt(p1.x)
      if (pl0 && pl0.isMoving) {
        lastMovingPlatformY = p0.y
      }

      let spawnObstacles = true
      let positions = null
      if (p0.y !== p1.y) {
        spawnObstacles = this.rnd.frac() < Math.sqrt(this.relativeRating)
      }
      if (spawnObstacles) {
        if (this.rnd.frac() < 0.2 * this.relativeRating) {
          positions = this.generateVerticalMovingObstacles(p0, p1, i)
        } else if (p0.noHeightInFront || p1.noHeightBehind) {
          positions = this.generateFloatingObstacles(p0, p1, p0.y === lastMovingPlatformY && (!pl1 || (pl0 && pl0.isMoving)))
        } else {
          positions = this.generateNormalObstacles(p0, p1)
        }
      }

      if (positions) {
        if (pMin1) {
          if (pl0 && pl0.typeName !== 'bPl') {
            let left = pl0.image.x - (pl0.width / 2) + 60
            const pl = this.getPlatformAt(lastX)
            if (pl && pl.height >= pl0.height) {
              left = Math.max(left, pl.image.x + (pl.width / 2) + 90)
            }
            const right = pl0.image.x + (pl0.width / 2) - 60
            const s = new Phaser.Math.Vector2(Math.max(left, lastX + 140), p0.y - 100)
            const e = new Phaser.Math.Vector2(Math.min(right, positions.startX - 140), p0.y - 100)
            const range = e.x - s.x
            let minRange = 300

            const hopsize = p0.x - pMin1.x
            const yDiff = p0.y - pMin1.y
            let forcePerc = -1
            if (hopsize > 600 && yDiff < -250) {
              this.log('forcing horizontal mover around ' + p0.x + ' to be at perc=1, as it would be too difficult otherwise')
              forcePerc = 1
              minRange = 400
            }

            if (range > minRange && range < 1000 && this.rnd.frac() < this.relativeRating) {
              let delay = 0
              for (var j = i - 1; j <= i + 1; j++) {
                if (this.guide.editor.points[j].x < e.x && this.guide.editor.points[j].x > s.x) {
                  let playerReachesAt = EST_FALL_DURATION + ((j + 1) * EST_HOP_DURATION) + 200
                  playerReachesAt += (this.guide.editor.points[j].y - 410) * 1 // adjust estimation when guide goes up/down, as we will travel faster/slower
                  let percInTween = (this.guide.editor.points[j].x - s.x) / range
                  // Make the percInTween the opposite of when the player would hit it:
                  if (percInTween > 0.5 && percInTween < 1.5) {
                    percInTween = 0
                  } else {
                    percInTween = 1
                  }
                  if (forcePerc >= 0) {
                    percInTween = forcePerc
                  }
                  const tweenDuration = 1000 * ((range) / 200) // (speed is always 200)
                  delay = percInTween - ((playerReachesAt / tweenDuration) % 2)
                  if (delay < 0) {
                    delay += 2
                  }
                }
              }
              this.spawnMovingObstacle(s, e, delay)
            }
          }
        }
        lastX = positions.endX
      }

      if (this.rnd.frac() < Math.sqrt(this.relativeRating)) {
        // if (this.rnd.frac() < 0.15 * this.relativeRating) {
        // this.generateTopMovingObstacles(p0, p1)
        // } else {
        this.generateTopObstacles(p0, p1, p2)
        // }
      }
    }

    this.endTopPlatform(this.lastTopObstacleX + 100)
  }

  generateTopMovingObstacles (p0, p1, i) {
    // var hopSize = p1.x - p0.x
    // var relativeHopSize = (hopSize - MIN_HOPSIZE) / (MAX_HOPSIZE - MIN_HOPSIZE)
    // var nextHopSize = p2.x - p1.x
    // var nextRelativeHopSize = (nextHopSize - MIN_HOPSIZE) / (MAX_HOPSIZE - MIN_HOPSIZE)

    // guidePos = this.guide.getOuterMostCurveAt(p0.x, p1.x, p0.y, p1.y, xAlongHop)

    let xAlongHop = 1// this.rnd.frac()// 1
    xAlongHop = this.guide.findTForXOuterMostCurve(p0.x, p1.x, p0.y, p1.y, Phaser.Math.Linear(p0.x, p1.x, xAlongHop))
    const guidePos = this.guide.getOuterMostCurveAt(p0.x, p1.x, p0.y, p1.y, xAlongHop)
    const obstacleX = guidePos.x
    const obstacleY = guidePos.y - this.makeTopObstacleEasier(this.relativeRating)

    // var desY = (Math.min(p0.y, p1.y) - 670)
    // var obstacleHeight = -1 * (obstacleY - desY)

    // NB: beware that the shape of a 'noHeight' obstacle is less tall, but wider
    const s = new Phaser.Math.Vector2(obstacleX, obstacleY)
    const e = new Phaser.Math.Vector2(obstacleX, obstacleY - this.rnd.between(300, 500))
    this.spawnMovingObstacle(s, e, this.rnd.frac())
  }

  generateTopObstacles (p0, p1, p2) {
    var hopSize = p1.x - p0.x
    var p2x = p2.x
    if (p2x === p1.x) {
      p2x = p1.x + (p1.x - p0.x)
    }
    var nextHopSize = p2x - p1.x

    var shape = this.rnd.between(SHAPE_LINE, SHAPE_SLOPEUP)
    let maxObstacles = 3
    if (hopSize < MIN_HOPSIZE * 1.2 || this.relativeRating < 0.32) {
      maxObstacles = 1
    } else if (shape === SHAPE_SLOPEDOWN || shape === SHAPE_SLOPEUP) {
      maxObstacles = 2
    }
    const nObstacles = this.rnd.between(1, maxObstacles)

    // triangles with 2 obstacles should be regarded as lines, to make the code easier..
    if (shape === SHAPE_TRIANGLE && nObstacles === 2) {
      shape = SHAPE_LINE
    }

    var xPositions = this.generateTopObstacleXpositions(shape, nObstacles, hopSize, nextHopSize)

    // Find out for LINE and TRIANGLE shapes, which of the obstacles is lowest:
    let lowestObstacleInfo = this.getTopObstacleInfoFor(p0, p1, p2, xPositions, 0)
    if (nObstacles > 1 && (shape === SHAPE_LINE || shape === SHAPE_TRIANGLE)) {
      for (var obstacleId = 1; obstacleId < nObstacles; obstacleId++) {
        const info = this.getTopObstacleInfoFor(p0, p1, p2, xPositions, obstacleId)
        if (info.y < lowestObstacleInfo.y) {
          lowestObstacleInfo = info
        }
      }
    }

    // Spawn Obstacles:
    for (var obstacleId = 0; obstacleId < nObstacles; obstacleId++) {
      const obstacleInfo = this.getTopObstacleInfoFor(p0, p1, p2, xPositions, obstacleId)

      // If SHAPE_LINE, make ALL obstacles the lowest height
      // If SHAPE_TRIANGLE, make only the left and the right one the lowest height
      if (nObstacles > 1 && ((shape === SHAPE_LINE) || (shape === SHAPE_TRIANGLE && nObstacles === 3 && (obstacleId === 0 || obstacleId === 2)))) {
        obstacleInfo.y = lowestObstacleInfo.y
        obstacleInfo.height = lowestObstacleInfo.height
      }

      let dontSpawn = false
      if (this.lastMovingObstacleX > 0) {
        if (obstacleInfo.x < this.lastMovingObstacleX + 140) {
          this.log('not spawning topObstacle at ' + obstacleInfo.x + 'because there is a mover in the way at ' + this.lastMovingObstacleX)
          dontSpawn = true
        }
      }

      if (!dontSpawn) {
        this.spawnTopObstacle(obstacleInfo.x, obstacleInfo.y, obstacleInfo.height)
      }
    }
  }

  getTopObstacleInfoFor (p0, p1, p2, xPositions, obstacleId) {
    var p2x = p2.x
    if (p2x === p1.x) {
      p2x = p1.x + (p1.x - p0.x)
    }

    let xAlongHop = xPositions[obstacleId]
    let guidePos
    if (xAlongHop < 1) {
      xAlongHop = this.guide.findTForXOuterCurve(p0.x, p1.x, p0.y, p1.y, Phaser.Math.Linear(p0.x, p1.x, xAlongHop))
      guidePos = this.guide.getOuterCurveAt(p0.x, p1.x, p0.y, p1.y, xAlongHop)
    } else if (xAlongHop > 1) {
      xAlongHop = this.guide.findTForXOuterCurve(p1.x, p2x, p1.y, p2.y, Phaser.Math.Linear(p1.x, p2x, xAlongHop - 1))
      guidePos = this.guide.getOuterCurveAt(p1.x, p2x, p1.y, p2.y, xAlongHop)
    } else {
      // xAlongHop is exactly 1. Prefer the guideLine that gives me the closest to the desired X
      // (if both are close, use the most forgiving guidePos)
      const xAlongHopL = this.guide.findTForXOuterCurve(p0.x, p1.x, p0.y, p1.y, Phaser.Math.Linear(p0.x, p1.x, xAlongHop))
      const guidePosL = this.guide.getOuterCurveAt(p0.x, p1.x, p0.y, p1.y, xAlongHopL)
      const xAlongHopR = this.guide.findTForXOuterCurve(p1.x, p2x, p1.y, p2.y, Phaser.Math.Linear(p1.x, p2x, xAlongHop - 1))
      const guidePosR = this.guide.getOuterCurveAt(p1.x, p2x, p1.y, p2.y, xAlongHopR)

      const desiredXPos = p1.x
      const diffL = Math.abs(guidePosL.x - desiredXPos)
      const diffR = Math.abs(guidePosR.x - desiredXPos)

      if (diffL < diffR) {
        guidePos = guidePosL
      } else if (diffR < diffL) {
        guidePos = guidePosR
      } else {
        if (guidePosR.y < guidePosL.y) {
          guidePos = guidePosR
        } else {
          guidePos = guidePosL
        }
      }
    }

    var obstacleHeight = -1 * (guidePos.y - (Math.min(p0.y, p1.y) - 670))
    return { x: guidePos.x, y: guidePos.y, height: obstacleHeight }
  }

  generateNormalObstaclesInsteadOfFloating (p0, p1, hopSize) {
    this.log('generating normal obstacle instead of floatinf between' + p0.x + ' and ' + p1.x)

    const pHalfX = Phaser.Math.Linear(p0.x, p1.x, 0.5)
    let extendPl0 = false
    let extendPl1 = false
    let leftLimit = 0
    let rightLimit = 0

    const pl0 = this.getPlatformAt(p0.x)
    const pl1 = this.getPlatformAt(p1.x)

    if (pl0 && pl0.typeName === 'sPl' && !pl0.isMoving && pl0.image.y - (pl0.height / 2) === p0.y - 10) {
      extendPl0 = true
    } else {
      leftLimit = 200 + 20 + PLATFORM_PADDING
    }

    if (pl1 && pl1.typeName === 'sPl' && !pl1.isMoving && pl1.image.y - (pl1.height / 2) === p1.y - 10) {
      extendPl1 = true
    } else {
      rightLimit = 200 + 20 + PLATFORM_PADDING
    }

    const info = this.generateNormalObstacles(p0, p1, leftLimit, rightLimit)

    if (extendPl0) {
      this.log('extending left platform to the right, towards ' + (info.endX + PLATFORM_PADDING))
      pl0.handles[0].setRight(info.endX + PLATFORM_PADDING)
    }

    if (extendPl1) {
      this.log('extending right platform to the left, towards.. ')
      if (p0.y === p1.y) {
        this.log('' + (info.startX - PLATFORM_PADDING))
        pl1.handles[0].setLeft(info.startX - PLATFORM_PADDING)
      } else {
        this.log('' + (info.endX + 80))
        pl1.handles[0].setLeft(info.endX + 80)
      }
    }

    if (!extendPl0 && (!extendPl1 || p0.y !== p1.y) && info.startX < 100000000 && info.endX > -100000000) {
      this.startPlatform(info.startX - PLATFORM_PADDING, p0.y - 10)
      this.endPlatform(info.endX + PLATFORM_PADDING)
    }

    return info
  }

  generateFloatingObstacles (p0, p1, aboveMovingPlatform) {
    const hopSize = p1.x - p0.x

    if (!aboveMovingPlatform && hopSize > (400 + 220)) {
      return this.generateNormalObstaclesInsteadOfFloating(p0, p1, hopSize)
    }

    const curveStart = this.guide.getInnerMostCurveAt(p0.x, p1.x, p0.y, p1.y, 0)
    const curveEnd = this.guide.getInnerMostCurveAt(p0.x, p1.x, p0.y, p1.y, 1)
    // const curveWidth = curveEnd.x - curveStart.x

    // const startPerc = 0
    // const minObsDist = MIN_OBSTACLE_DIST * 1.5

    let shape = SHAPE_LINE
    let nObstacles = 1
    let xPositions = [this.rnd.realInRange(0.3, 0.7)]// .frac()]// this.generateCenteredPositions(startPerc, nObstacles)
    // const aboveMovingPlatform = // .typeName ==
    if (aboveMovingPlatform && this.rnd.frac() < 0.5) {
      nObstacles = 2
      if (hopSize > 400) {
        xPositions = [0, 1]
        shape = SHAPE_LINE
      } else {
        xPositions = [0.5, 0.5]
        shape = SHAPE_TRIANGLE
      }
    }

    // Spawn Obstacles:
    let startX = 100000000
    let endX = -100000000
    for (var obstacleId = 0; obstacleId < nObstacles; obstacleId++) {
      const xAlongHop = this.guide.findTForXInnerMostCurve(p0.x, p1.x, p0.y, p1.y, Phaser.Math.Linear(curveStart.x, curveEnd.x, xPositions[obstacleId]))
      const guidePos = this.guide.getInnerMostCurveAt(p0.x, p1.x, p0.y, p1.y, xAlongHop)
      let obstacleX = guidePos.x
      let obstacleHeight = p0.y - (guidePos.y)

      if (p1.y > p0.y) {
        obstacleHeight += (p1.y - p0.y)
      }

      let dontSpawn = false

      if (obstacleHeight > 0) {
        obstacleHeight = Math.max(1, obstacleHeight)

        if (shape === SHAPE_TRIANGLE) {
          obstacleHeight -= obstacleId * 140/// = obstacleId + 1
        } else if (shape === SHAPE_LINE) {
          obstacleX -= (xPositions[obstacleId] - 0.5) * (160 - (this.relativeRating * 160))
        }

        let spawnY = Math.max(p0.y, p1.y) - obstacleHeight
        spawnY += this.makeFloatingObstacleEasier()
        startX = Math.min(startX, obstacleX)
        endX = Math.max(obstacleX, endX)

        if (spawnY > p1.y) {
          this.log('not spawning flObs because it would be too low' + obstacleX)
          dontSpawn = true
        }

        if (hopSize < 300) {
          this.log('not spawning flObs because hop is too narrow' + obstacleX)
          dontSpawn = true
        }

        if (!dontSpawn) {
          var def = { type: 'obs', data: { x: obstacleX, y: spawnY, height: obstacleHeight, noHeight: true } }
          this.scene.spawner.spawnFromDef(def, false)
        }
      }
    }

    return { startX, endX }
  }

  testDelay (delay, p0, p1, y0, y1, hopIndex, xAlongHop) {
    const guidePos = this.guide.getCurveAt(p0.x, p1.x, p0.y, p1.y, xAlongHop)
    const rangeTop = guidePos.y - y0
    const rangeBottom = y1 - guidePos.y

    // Make the percInTween the opposite of when the player would hit it:
    const percInTween = rangeTop / (rangeBottom + rangeTop) // 0..1

    // with this delay, we will be in 'perc' when teh player arrives
    let playerReachesAt = EST_FALL_DURATION + ((hopIndex + 1 + xAlongHop) * EST_HOP_DURATION)
    playerReachesAt += (p0.y - 410) * 1 // adjust estimation when guide goes up/down, as we will travel faster/slower
    const tweenDuration = 1000 * ((rangeBottom + rangeTop) / 200) // (speed is always 200)
    let perc = delay + ((playerReachesAt / tweenDuration) % 2)

    perc %= 2
    if (perc > 1) {
      perc = 1 - (perc - 1)
    }

    this.log('intersection between tween and guide is at percentage: ' + percInTween)
    this.log('with ', delay, 'delay, the tween will be at percentage:' + perc)

    return Math.abs(perc - percInTween) > 0.4
  }

  findDelayFor (p0, p1, y0, y1, hopIndex, xAlongHop, nObstacles) {
    const guidePos = this.guide.getCurveAt(p0.x, p1.x, p0.y, p1.y, xAlongHop)
    const rangeTop = guidePos.y - y0
    const rangeBottom = y1 - guidePos.y

    // Make the percInTween the opposite of when the player would hit it:
    let percInTween = 0
    const intersection = rangeTop / (rangeBottom + rangeTop)
    if (p1.y > p0.y + 200 && xAlongHop > 0.5) {
      if (intersection < 0.3) {
        percInTween = 1
      } else {
        percInTween = 0
      }
    } else {
      if (intersection < 0.5) {
        percInTween = 1
      } else {
        percInTween = 0
      }
    }

    if (nObstacles === 1) {
      this.log('only one mover. percInTween was ' + percInTween + 'as player will be at ' + intersection)
      const t = xAlongHop > 0.5 ? 1 - xAlongHop : xAlongHop
      const ajdustment = this.relativeRating * 2 * t * Math.min(1, (p1.x - p0.x) / (MAX_HOPSIZE * 0.75))
      percInTween = Phaser.Math.Linear(percInTween, intersection + 0.2, ajdustment)
      this.log('adjusted, by difficulty, to: ' + percInTween)
      percInTween = 2 - percInTween
    }

    let playerReachesAt = EST_FALL_DURATION + ((hopIndex + 1 + xAlongHop) * EST_HOP_DURATION)
    playerReachesAt += (p0.y - 410) * 1 // adjust estimation when guide goes up/down, as we will travel faster/slower
    const tweenDuration = 1000 * ((rangeBottom + rangeTop) / 200) // (speed is always 200)
    let delay = percInTween - ((playerReachesAt / tweenDuration) % 2)
    if (delay < 0) {
      delay += 2
    }

    return delay
  }

  generateVerticalMovingObstacles (p0, p1, hopIndex) {
    const hopSize = p1.x - p0.x
    const curveStart = p0
    const curveEnd = p1

    const maxObstacles = Math.min(2, Math.floor((hopSize - MIN_MOVER_DIST) / MIN_MOVER_DIST))
    const nObstacles = this.rnd.between(1, Math.ceil(this.relativeRating * maxObstacles))

    const minStartPerc = ((2 - this.relativeRating) * MIN_MOVER_DIST) / hopSize
    const maxStartPerc = ((hopSize - ((nObstacles - 1) * MIN_MOVER_DIST)) / 2) / hopSize
    const startPerc = this.rnd.realInRange(minStartPerc, maxStartPerc)
    const endPerc = 1 - startPerc
    const xPositions = this.generateCenteredPositions(startPerc, endPerc, nObstacles)

    let difficultyMP = 0
    if (nObstacles === 1) {
      difficultyMP = this.relativeRating
    }

    let prevY0
    let prevY1
    let prevObs = null
    // let prevDelay
    let prevXAlongHop
    let y0 = 0
    let y1 = 0
    let delay = 0
    let startX = -10000
    let endX = -10000
    const leadingObstacleIndex = -1
    for (var obstacleId = 0; obstacleId < nObstacles; obstacleId++) {
      const xAlongHop = this.guide.findTForXCurve(p0.x, p1.x, p0.y, p1.y, Phaser.Math.Linear(curveStart.x, curveEnd.x, xPositions[obstacleId]))
      const guidePos = this.guide.getCurveAt(p0.x, p1.x, p0.y, p1.y, xAlongHop)
      const obstacleX = guidePos.x
      const obstacleHeight = p0.y - (guidePos.y)

      let rangeTop = 650 - obstacleHeight
      let rangeBottom = 550 - rangeTop

      // Some adjustment to make sure we dont move through a platform:
      if (guidePos.y + rangeBottom > p1.y - 90) {
        const p = this.getPlatformAt(obstacleX + 70)
        if (p && p.typeName === 'sPl' && p.image.y - (p.height / 2) < guidePos.y + rangeBottom) {
          this.log('Moving vertMover at' + obstacleX + 'upwards, as it would look ugly otherwise')
          const diff = Math.abs(p1.y - p0.y)
          rangeTop += diff
          rangeBottom -= diff
        }
      }

      y0 = guidePos.y - rangeTop
      y1 = guidePos.y + rangeBottom
      delay = this.findDelayFor(p0, p1, y0, y1, hopIndex, xAlongHop, nObstacles)
      let delayIsGood = true

      // adjust mine and prevObs delays to either sync both obstacles, or put them in exact opposite sync:
      if (prevObs) {
        if (y0 !== prevY0 || y1 !== prevY1) {
          this.log('adjusting delay and positions of first mover, because second is blocked!')
          prevObs.moveComponent.refreshPath(new Phaser.Math.Vector2(prevObs.moveComponent.p0.x, y0), new Phaser.Math.Vector2(prevObs.moveComponent.p1.x, y1))
          prevObs.moveComponent.delay = this.findDelayFor(p0, p1, y0, y1, hopIndex, prevXAlongHop, nObstacles)
        }

        this.log('my delay is either the same, or the exact opposite as the first movers..')
        delay = prevObs.moveComponent.delay
        delayIsGood = this.testDelay(delay, p0, p1, y0, y1, hopIndex, xAlongHop)
        if (!delayIsGood) {
          delay += 1
          delayIsGood = this.testDelay(delay, p0, p1, y0, y1, hopIndex, xAlongHop)
        }

        if (!delayIsGood) {
          this.log('not spawning second mover because the player would probably hit it')
        }
      }

      let dontSpawn = false
      if (this.lastTopObstacleX > 0) {
        if (obstacleX < this.lastTopObstacleX + 140) {
          this.log('not spawning moving obstacle at ' + obstacleX + ' beacuse of topObstace at ' + this.lastTopObstacleX)
          dontSpawn = true
        }
      }

      if (!dontSpawn && delayIsGood) {
        prevObs = this.spawnMovingObstacle({ x: obstacleX, y: y0 }, { x: obstacleX, y: y1 }, delay)
        prevXAlongHop = xAlongHop
        this.lastMovingObstacleX = obstacleX
        startX = Math.min(startX, obstacleX)
        endX = Math.max(obstacleX, endX)
      }
    }

    return { startX, endX }
  }

  generateObstaclePositions (hopSize, forceMinStartPerc, forceMaxEndPerc) {
    let minStartPerc = 0
    let maxStartPerc = 0.5
    let startPerc = 0
    let endPerc = 1

    if (this.relativeRating < 0.16) {
      minStartPerc = 0.5
      // maxStartPerc = 0.5
    } else if (this.relativeRating < 0.21) {
      minStartPerc = 0.5 - (0.75 * (MIN_OBSTACLE_DIST / hopSize))
      minStartPerc = Math.max(minStartPerc, (MIN_OBSTACLE_DIST / hopSize))
      // maxStartPerc = 0.5
    } else if (this.relativeRating < 0.28) {
      minStartPerc = 0.5 - (1.25 * (MIN_OBSTACLE_DIST / hopSize))
      // maxStartPerc = 0.5
    } else if (this.relativeRating < 0.89) {
      minStartPerc = 0.5 - (1.75 * (MIN_OBSTACLE_DIST / hopSize))
      // maxStartPerc = 0.5
    } else {
      minStartPerc = Math.min(0.5, (MIN_OBSTACLE_DIST / hopSize))
      // if (hopSize > MAX_HOPSIZE) {
      //   minStartPerc *= 2
      // } else if (hopSize > MAX_HOPSIZE - 100) {
      //   minStartPerc *= 1.5
      // }
      maxStartPerc = Math.min(maxStartPerc, 2 * minStartPerc)
    }

    startPerc = this.rnd.realInRange(minStartPerc, maxStartPerc)
    // if (maxWidth < hopSize) {
    // const leftMostPerc = 330 / hopSize
    startPerc = Math.max(startPerc, forceMinStartPerc)
    // }
    startPerc = Math.min(startPerc, 0.5)
    endPerc = 1 - startPerc
    endPerc = Math.min(endPerc, forceMaxEndPerc)
    const nObstacles = 1 + Math.floor(((endPerc - startPerc) * hopSize) / MIN_OBSTACLE_DIST)
    const xPositions = this.generateCenteredPositions(startPerc, endPerc, nObstacles)

    let shape = SHAPE_LINE
    if (this.relativeRating < 0.21) {
      shape = SHAPE_LINE
    } else if (this.relativeRating < 0.35) {
      shape = nObstacles === 3 ? SHAPE_TRIANGLE : SHAPE_LINE
    } else {
      shape = this.rnd.between(SHAPE_LINE, SHAPE_SLOPEUP)
    }

    //= ===
    // const startPerc = 0.25
    // const endPerc = 1 - startPerc
    // const nObstacles = 1 + Math.floor(((endPerc - startPerc) * curveWidth) / MIN_OBSTACLE_DIST)
    // const xPositions = this.generateCenteredPositions(startPerc, nObstacles)
    // const shape = this.rnd.between(SHAPE_LINE, SHAPE_SLOPEUP)

    if (nObstacles < 1) {
      debugger
    }
    return { shape, xPositions, nObstacles }
  }

  generateNormalObstacles (p0, p1, leftLimit = 0, rightLimit = 0) {
    let startX = 100000000
    let endX = -100000000

    const curveStart = this.guide.getInnerCurveAt(p0.x, p1.x, p0.y, p1.y, 0)
    const curveEnd = this.guide.getInnerCurveAt(p0.x, p1.x, p0.y, p1.y, 1)
    const curveWidth = curveEnd.x - curveStart.x

    const minStartPerc = leftLimit / (p1.x - p0.x)
    const maxEndPerc = 1 - (rightLimit / (p1.x - p0.x))
    if (minStartPerc > maxEndPerc) {
      return { startX, endX }
    }
    const spawnInfo = this.generateObstaclePositions(curveWidth, minStartPerc, maxEndPerc)

    let lineHeight = -10
    const slopeStart = 50
    let slopeEnd = 100

    // Prepare for slopeUp and slopeDown shapes:
    if (spawnInfo.shape === SHAPE_SLOPEUP || spawnInfo.shape === SHAPE_SLOPEDOWN) {
      const lastAlongHop = this.guide.findTForXInnerCurve(p0.x, p1.x, p0.y, p1.y, Phaser.Math.Linear(curveStart.x, curveEnd.x, spawnInfo.xPositions[spawnInfo.nObstacles - 1]))
      const guidePos = this.guide.getInnerCurveAt(p0.x, p1.x, p0.y, p1.y, lastAlongHop)
      slopeEnd = p0.y - (guidePos.y)
    }

    // Spawn Obstacles:

    for (var obstacleId = 0; obstacleId < spawnInfo.nObstacles; obstacleId++) {
      const xAlongHop = this.guide.findTForXInnerCurve(p0.x, p1.x, p0.y, p1.y, Phaser.Math.Linear(curveStart.x, curveEnd.x, spawnInfo.xPositions[obstacleId]))
      const guidePos = this.guide.getInnerCurveAt(p0.x, p1.x, p0.y, p1.y, xAlongHop)
      const obstacleX = guidePos.x
      let obstacleHeight = p0.y - (guidePos.y)

      if (spawnInfo.shape === SHAPE_SLOPEUP && spawnInfo.nObstacles > 1) {
        obstacleHeight = slopeStart + (obstacleId * ((slopeEnd - slopeStart) / (spawnInfo.nObstacles - 1)))
      }

      if (spawnInfo.shape === SHAPE_LINE || spawnInfo.shape === SHAPE_SLOPEDOWN) {
        // the first obstacle determines the lineHeight
        if (lineHeight <= -10) {
          lineHeight = obstacleHeight
          slopeEnd = Math.max(Math.min(slopeEnd, this.rnd.between(0, lineHeight * (1 - (0.2 * (spawnInfo.nObstacles - 1))))), -4)
        }
        obstacleHeight = Math.min(obstacleHeight, lineHeight)
        if (spawnInfo.shape === SHAPE_SLOPEDOWN && obstacleId > 0) {
          obstacleHeight = lineHeight - (obstacleId * ((lineHeight - slopeEnd) / (spawnInfo.nObstacles - 1)))
        }
      }

      if (p1.y > p0.y) {
        obstacleHeight += (p1.y - p0.y)
      }

      if (obstacleHeight > 0) {
        obstacleHeight = Math.max(50, obstacleHeight - this.makeObstacleEasier())

        // filter out some really nasty obstacles:
        if (obstacleHeight > 400 && p1.x - p0.x < 350) {
          obstacleHeight = Math.max(50, obstacleHeight - 100)
        }

        const spawnY = Math.max(p0.y, p1.y) - obstacleHeight
        var def = { type: 'obs', data: { x: obstacleX, y: spawnY, height: obstacleHeight, noHeight: false } }

        // sometimes omit an obstacle to keep things looking fresh:
        var dontSpawn = false
        if (spawnInfo.nObstacles > 2) {
          if (this.rnd.frac() < 0.15) {
            this.log('Randomly not spawning obstacle at ' + obstacleX)
            dontSpawn = true
          }
        }

        const p = this.getPlatformAt(obstacleX)
        if (p && p.image.y - (p.height / 2) < spawnY) {
          this.log('Not spawning obstacle at ' + obstacleX + ' as it would look ugly')
          dontSpawn = true
        }

        if (!dontSpawn) {
          this.scene.spawner.spawnFromDef(def, false)
        }

        // do set this:
        startX = Math.min(startX, obstacleX)
        endX = Math.max(obstacleX, endX)
      }
    }

    return { startX, endX }
  }

  makeTopObstacleEasier (relativeRating) {
    return Phaser.Math.Linear(320, 0, Math.sqrt(this.relativeRating))
  }

  makeFloatingObstacleEasier () {
    return Phaser.Math.Linear(120, 0, this.relativeRating)
  }

  makeObstacleEasier () {
    return Phaser.Math.Linear(320, 0, Math.sqrt(this.relativeRating))

    // Based on difficulty, set max obstacle height
    var maxObstacleHeight = 320
    if (relativeRating <= 0.08) {
      maxObstacleHeight = relativeRating * 2200 // 50..175
    } else if (relativeRating <= 0.28) {
      maxObstacleHeight = 140 + (relativeRating * 500) // 180..280
    } else {
      maxObstacleHeight = 320 - ((1 - relativeRating) * 55) // 280..320
    }

    // Apply difficulty
    const obstacleY = height * (maxObstacleHeight / 320)

    // if the hop is really wide, make it a bit easier on the player
    // if (relativeHopSize > 0.9) {
    // obstacleY = Math.max(obstacleY - 30, -4)
    // }

    // Don't allow an obstacle to be too close to a previous high topObstacle
    // if (this.lastSpawnedTopObstacle) {
    //   var obsX = this.lastSpawnedTopObstacle.getX()
    //   var obsY = this.lastSpawnedTopObstacle.getY()
    //   var xDist = x - obsX

    //   if (xDist > 0 && xDist < MIN_OBSTACLE_DIST * 2) {
    //     if (xDist < MIN_OBSTACLE_DIST / 2) {
    //       // this.log('(Re)moving obstacle at x=' + obstacleX)
    //       obstacleY -= 100
    //     }

    //     // Too close on the y-axis:
    //     if (obstacleY - obsY < 200) {
    //       var newObstacleY = Math.min(obstacleY, 580 - obsY - Math.max(0, 220 - xDist) - ((1 - this.relativeRating) * 150)) // Move me down by some margin
    //       if (newObstacleY !== obstacleY) {
    //         // this.log('Moving obstacle at xPos: ' + obstacleX + ' from yPos: ' + obstacleY + ' to: ' + newObstacleY)
    //         obstacleY = newObstacleY
    //       }
    //     }
    //   }
    // }

    return height - obstacleY
  }

  generateTopObstacleXpositions (shape, numObstacles, hopSize, nextHopSize) {
    var pos = [numObstacles]
    if (numObstacles === 1) {
      pos[0] = 1
      return pos
    }

    var leftDistPerc = MIN_OBSTACLE_DIST / hopSize
    var rightDistPerc = MIN_OBSTACLE_DIST / nextHopSize

    if (shape === SHAPE_LINE || shape === SHAPE_TRIANGLE) {
      if (numObstacles === 3) {
        pos[0] = 1 - leftDistPerc
        pos[1] = 1
        pos[2] = 1 + rightDistPerc
      } else if (numObstacles === 2) {
        pos[0] = 1 - (leftDistPerc / 2)
        pos[1] = 1 + (rightDistPerc / 2)
      }
    } else if (shape === SHAPE_SLOPEUP) {
      pos[0] = 1
      pos[1] = 1 + rightDistPerc
    } else if (shape === SHAPE_SLOPEDOWN) {
      pos[0] = 1 - leftDistPerc
      pos[1] = 1
    }

    return pos
  }

  generateObstacleXpositionsByPerc (startPerc, nObstacles, minObstacleDist, hopSize) {
    var pos = [nObstacles]

    var percLeft = 1 - startPerc
    var stepSize = 1

    stepSize = (percLeft - startPerc) / (nObstacles - 1)
    for (var i = 0; i < nObstacles; i++) {
      pos[i] = startPerc + (i * stepSize)
    }
    return pos
  }

  // Returns 'nObstacles' x-positions, centered around 0.5, starting at 'startPerc'
  generateCenteredPositions (startPerc, endPerc, nObstacles) {
    var pos = [nObstacles]

    if (nObstacles === 1) {
      pos[0] = Phaser.Math.Linear(startPerc, endPerc, 0.5)
      return pos
    }

    // var percLeft = 1 - startPerc
    // var stepSize = (percLeft - startPerc) / (nObstacles - 1)
    var stepSize = (endPerc - startPerc) / (nObstacles - 1)

    for (var i = 0; i < nObstacles; i++) {
      pos[i] = startPerc + (i * stepSize)
    }
    return pos
  }

  // Returns 'nObstacles' x-positions, equally-distanced from eachother, starting at 'startPerc', but NOT (necessarily) centered around 0.5
  generateNonCenteredPositions (startPerc, nObstacles, hopSize, minObstacleDist) {
    var pos = [nObstacles]

    if (nObstacles === 1) {
      pos[0] = startPerc
      return pos
    }

    var percLeft = 1 - startPerc
    // var stepSize = (percLeft - startPerc) / (nObstacles - 1)

    var maxStepSize = percLeft / nObstacles
    var minStepSize = minObstacleDist / hopSize
    var stepSize = Phaser.Math.RND.realInRange(minStepSize, maxStepSize)

    for (var i = 0; i < nObstacles; i++) {
      pos[i] = startPerc + (i * stepSize)
    }
    return pos
  }

  generateObstacleXpositions (shape, numObstacles, hopSize, relativeRating, minObstacleDist = MIN_OBSTACLE_DIST) {
    var pos = [numObstacles]
    var maxStartPerc = 1
    var minStartPerc = ((2 - relativeRating) * minObstacleDist) / hopSize // TODO: maybe this is too strict? At least not in line with calculation for maxObstacles above..

    if (numObstacles === 1) {
      var x = Phaser.Math.RND.realInRange(minStartPerc, 1 - minStartPerc)
      pos[0] = x
      return pos
    }

    // TODO: if rR < 0.22, the obstacles are always centered

    switch (shape) {
      default:
      case SHAPE_LINE:
      case SHAPE_TRIANGLE:
        // Keep symmetry:
        maxStartPerc = ((hopSize - ((numObstacles - 1) * minObstacleDist)) / 2) / hopSize
        break
      case SHAPE_SLOPEDOWN:
      case SHAPE_SLOPEUP:
        // Symmetry is not needed:
        maxStartPerc = (hopSize - (numObstacles * minObstacleDist)) / hopSize
        break
    }

    if (maxStartPerc < minStartPerc) {
      // debugger
      // this.log('ERROR: TOO MANY OBSTACLES (' + numObstacles + ') FOR THIS HOP!!')
    }

    var startPerc = Phaser.Math.RND.realInRange(minStartPerc, maxStartPerc)
    var percLeft = 1 - startPerc
    var stepSize = 1

    switch (shape) {
      case SHAPE_TRIANGLE:
        // While keeping symmetry, don't always space obstacles out in equal parts (e.g. allow obstacles at 1/6th, 3/6th and 5/6th)
        stepSize = (percLeft - startPerc) / (numObstacles - 1)
        break
        // Keep objects evenyly spaced, but symmetry is not neccessary:
      default:
        // TODO: this calculation of maxStepSize is incorrect (at least for SHAPE_LINE), as it doesnt leave enough space at the end
        var maxStepSize = percLeft / numObstacles
        var minStepSize = minObstacleDist / hopSize
        stepSize = Phaser.Math.RND.realInRange(minStepSize, maxStepSize)
        break
    }

    for (var i = 0; i < numObstacles; i++) {
      pos[i] = startPerc + (i * stepSize)
    }
    return pos
  }

  // distributes nPies over nPeople
  generateRandomDistribution (nPies, nPeople) {
    var ret = [nPeople]
    var total = 0
    var r = 0

    // give each person a random amount of slices
    for (var i = 0; i < nPeople; i++) {
      r = Phaser.Math.RND.frac() * nPies
      total += r
      ret[i] = r
    }

    // now 'normalize' the slices
    // and don't give any hop an added difficulty of more than 0.5..
    for (i = 0; i < nPeople; i++) {
      ret[i] = Math.min(0.5, ret[i] / total)
    }

    return ret
  }

  generateHopTypes (relativeRating, nHops) {
    var ret = [nHops]
    var hasObstacle = false
    var hasTopObstacle = false
    var hasMovingObstacle = false
    var hasGap = false

    var nHopsWithTopObstacles = 0
    var nHopsWithMovingObstacles = 0
    var nHopsWithGaps = 0

    if (relativeRating < 0.045) {
      nHopsWithTopObstacles = 0
      nHopsWithMovingObstacles = 0
      nHopsWithGaps = 0
    } else if (relativeRating < 0.11) {
      nHopsWithTopObstacles = Phaser.Math.RND.between(0, 1)
      nHopsWithMovingObstacles = 0
      nHopsWithGaps = 1 - nHopsWithTopObstacles
    } else if (relativeRating < 0.15) {
      nHopsWithTopObstacles = 0
      nHopsWithMovingObstacles = nHops// Phaser.Math.RND.between(1, nHops)
      nHopsWithGaps = 0
    } else if (relativeRating < 0.23) {
      nHopsWithTopObstacles = 1
      nHopsWithMovingObstacles = 0
      nHopsWithGaps = Phaser.Math.RND.between(0, 1)
    } else if (relativeRating < 0.38) {
      nHopsWithTopObstacles = Phaser.Math.RND.between(0, 2)
      nHopsWithMovingObstacles = nHopsWithMovingObstacles === 0 ? 1 : 0
      nHopsWithGaps = Phaser.Math.RND.between(0, Math.min(nHops, 3))
    } else if (relativeRating < 0.75) {
      nHopsWithTopObstacles = Phaser.Math.RND.between(1, 3)
      nHopsWithMovingObstacles = Phaser.Math.RND.between(0, 3)
      nHopsWithGaps = Phaser.Math.RND.between(0, 3)
    } else { // if (relativeRating < )
      nHopsWithTopObstacles = Phaser.Math.RND.between(2, nHops)
      nHopsWithMovingObstacles = Phaser.Math.RND.between(0, Math.floor(nHops / 2))
      nHopsWithGaps = Phaser.Math.RND.between(0, 2)
    }

    var nTopHopsFilledIn = 0
    var nMovingHopsFilledIn = 0
    var startWithTopOrMovingIndex = this.rnd.between(0, Math.max(0, nHops - nHopsWithTopObstacles - nHopsWithMovingObstacles))

    var nextHopSize = 0
    var thisHopSize = 0
    for (var i = 0; i < nHops; i++) {
      thisHopSize = this.guideData[i + 1] - this.guideData[i]

      if (i < nHops - 1) {
        nextHopSize = this.guideData[i + 2] - this.guideData[i + 1]
      }

      // TODO: this has all the topObstacles being spawned at the start,
      // and the moving obstacles being spawned at the end.
      // Move that around a bit..

      if (i >= startWithTopOrMovingIndex && i < nHopsWithTopObstacles + nHopsWithMovingObstacles) {
        // this is either a top, moving or both
      }

      // hasTopObstacle = i < nHopsWithTopObstacles && i < nHops - 1 && (nextHopSize - thisHopSize) < 400
      // hasMovingObstacle = !hasTopObstacle && i < nHopsWithTopObstacles + nHopsWithMovingObstacles
      hasTopObstacle = Phaser.Math.RND.frac() < nHopsWithTopObstacles / nHops

      // Don't put top obstacles after extermely short hops, or at the end (?)
      hasTopObstacle = hasTopObstacle /* && i < nHops - 1 */ && (nextHopSize - thisHopSize) < (MIN_HOPSIZE * 1.3)

      hasMovingObstacle = Phaser.Math.RND.frac() < nHopsWithMovingObstacles / nHops

      hasGap = Phaser.Math.RND.frac() < nHopsWithGaps / nHops

      // Fill unfilled hops up with obstacles:
      hasObstacle = !hasMovingObstacle && !hasGap

      // Limit obstacle placement if there is a topObstacle following, based on difficulty:
      if (hasObstacle && hasTopObstacle) {
        if (relativeRating < 0.4) {
          hasObstacle = false
        } else if (relativeRating < 0.7) {
          hasObstacle = Phaser.Math.RND.frac() < 0.5
        }
      }

      // hasObstacle = true// relativeRating < 0.1 || Phaser.Math.RND.frac() < 0.65
      // hasMovingObstacle = false//! hasObstacle && relativeRating >= 0.1// && rnd.frac() < 0.75
      // hasGap = false// relativeRating >= 0.08 && !hasObstacle && !hasMovingObstacle && Phaser.Math.RND.frac() < 0.35 // if there is an obstacle, there might also be a gap, but we do that later
      // hasTopObstacle = false// i < nHops - 1 && (hasObstacle || hasGap ? Phaser.Math.RND.frac() < 0.25 : true)// rnd.frac() < 0.75)

      ret[i] = { hasObstacle, hasTopObstacle, hasMovingObstacle, hasGap }
      // this.log(ret[i])
    }

    return ret
  }
}
